import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { EmployeeFaltasManager } from './EmployeeFaltasManager';

export interface EmployeeFaltasDialogProps {
  open: boolean;
  employeeId: number | null;
  employeeName?: string;
  onClose: () => void;
}

export function EmployeeFaltasDialog({
  open,
  employeeId,
  employeeName,
  onClose,
}: EmployeeFaltasDialogProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {employeeName
          ? t('features.colaboradores.faltas.dialogTitleNamed', { nome: employeeName })
          : t('features.colaboradores.faltas.dialogTitle')}
        <IconButton onClick={onClose} aria-label={t('common.close')} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {employeeId !== null && <EmployeeFaltasManager employeeId={employeeId} />}
      </DialogContent>
    </Dialog>
  );
}
